import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { isAutheticated } from "../../../auth/authhelper";
import { API } from "../../../../API";
import axios from "axios";

const ShopBanner = () => {
    const { token } = isAutheticated();
    const [currentBanner, setCurrentBanner] = useState();
    const [newBanner, setNewBanner] = useState(null);
    const [preview, setPreview] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadBannerData, setIsLoadBannerData] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [message, setMessage] = useState(null); // To display success/error messages

    useEffect(() => {
        async function fetchData() {
            setIsLoadBannerData(true); // Set loading to true before starting the fetch
            try {
                const res = await axios.get(`${API}/api/shop-banner`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log(res?.data);
                setCurrentBanner(res?.data);
            } catch (error) {
                console.error("Error fetching the banner:", error.response?.data?.message || error.message);
                // setMessage({
                //     type: "error",
                //     text: `Error fetching the banner: ${error.response?.data?.message || error.message}`,
                // });
            } finally {
                setIsLoadBannerData(false); // Set loading to false after the fetch
            }
        }

        fetchData();
    }, [token]); // This will run when the token change

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setNewBanner(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (newBanner && title && description) {
            setIsLoading(true);
            const formData = new FormData();
            formData.append("banner", newBanner);
            formData.append("title", title);
            formData.append("description", description);

            try {
                const res = await axios.post(`${API}/api/shop-banner/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                });
                setCurrentBanner(res.data?.banner);
                setNewBanner(null);
                setPreview(null);
                setTitle("");
                setDescription("");
                setMessage({ type: "success", text: "Banner updated successfully!" });
                hideMessage(); // Hide message after 3 seconds
            } catch (error) {
                console.error("Error uploading banner:", error);
                setMessage({
                    type: "error",
                    text: `Failed to update banner: ${error.response?.data?.message || error.message}`,
                });
                hideMessage(); // Hide message after 3 seconds
            } finally {
                setIsLoading(false);
            }
        } else {
            setMessage({ type: "error", text: "Please fill all fields and upload a banner." });
            hideMessage(); // Hide message after 3 seconds
        }
    };

    const handleDelete = async () => {
        const confirmDelete = window.confirm("Are you sure you want to delete the current banner?");
        if (confirmDelete) {
            setIsDeleting(true);
            try {
                const res = await axios.delete(`${API}/api/shop-banner`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setCurrentBanner("");
                setMessage({ type: "success", text: "Banner deleted successfully!" });
                hideMessage(); // Hide message after 3 seconds
            } catch (error) {
                console.error("Error deleting banner:", error);
                setMessage({
                    type: "error",
                    text: `Failed to delete banner: ${error.response?.data?.message || error.message}`,
                });
                hideMessage(); // Hide message after 3 seconds
            } finally {
                setIsDeleting(false);
            }
        }
    };

    const closeMessage = () => setMessage(null);

    const hideMessage = () => {
        setTimeout(() => {
            setMessage(null);
        }, 3000); // Hide message after 3 seconds
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="container py-5">
                        <h1 className="mb-4">Manage Shop Banner</h1>

                        {message && (
                            <div
                                className={`alert alert-${message.type === "success" ? "success" : "danger"} alert-dismissible fade show`}
                                role="alert"
                            >
                                {message.text}
                                <button type="button" className="btn-close" onClick={closeMessage}></button>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-lg-6 col-md-8 col-12 mb-4">
                                <h5>Current Banner</h5>
                                <div className="border p-3 rounded text-center">
                                    {isLoadBannerData ? (
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        <>
                                            {currentBanner ? (
                                                <>
                                                    <div className="mb-4">
                                                        {/* Title Section */}
                                                        {/* <h4 className="text-dark font-weight-bold">Title:</h4> */}
                                                        <label htmlFor="title" className="form-label">
                                                            Title:
                                                        </label>
                                                        <p className="bg-light p-2 rounded shadow-sm text-dark">{currentBanner?.title}</p>
                                                    </div>

                                                    <div className="mb-4">
                                                        {/* Description Section */}
                                                        <label htmlFor="title" className="form-label">
                                                            Description:
                                                        </label>
                                                        {/* <h4 className="text-dark font-weight-bold">Description:</h4> */}
                                                        <p className="bg-light p-2 rounded shadow-sm text-dark">{currentBanner?.description}</p>
                                                    </div>

                                                    <div className="border p-4 rounded-lg bg-light text-center shadow-lg">
                                                        {/* Image Section */}
                                                        <div className="d-flex justify-content-center mb-3">
                                                            <img
                                                                src={currentBanner?.image?.url}
                                                                alt="Current Shop Banner"
                                                                className="img-fluid rounded"
                                                                style={{ maxHeight: "150px", objectFit: "cover" }}
                                                            />
                                                        </div>

                                                        <div className="mt-3">
                                                            {/* Delete Button */}
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={handleDelete}
                                                                disabled={isDeleting}
                                                            >
                                                                {isDeleting ? "Deleting..." : "Delete Banner"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="border p-4 rounded-lg bg-light text-center shadow-lg">
                                                    <p className="text-muted">No banner uploaded. Please upload a banner.</p>
                                                </div>
                                            )}

                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-8 col-12">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="title" className="form-label">
                                            Title <small>(Max 50 characters)</small>
                                        </label>
                                        <input
                                            type="text"
                                            id="title"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value.slice(0, 50))}
                                            placeholder="Enter banner title"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">
                                            Description <small>(Max 250 characters)</small>
                                        </label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value.slice(0, 250))}
                                            placeholder="Enter banner description"
                                            rows="3"
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="banner" className="form-label">
                                            Upload New Banner <small>(1260x750 px)</small>
                                        </label>
                                        <input
                                            type="file"
                                            id="banner"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            required={!currentBanner}
                                        />
                                    </div>

                                    {preview && (
                                        <div className="mb-3">
                                            <h5>Preview</h5>
                                            <div className="border p-3 rounded">
                                                <img
                                                    src={preview}
                                                    alt="Banner Preview"
                                                    className="img-fluid rounded"
                                                // style={{ maxHeight: "200px" }}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? "Uploading..." : currentBanner ? "Update Banner" : "Upload Banner"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShopBanner;
